<template>
  <footer>
    <a>投诉电话:12315</a>
    <a class="commit">
      欢迎咨询
    </a>
  </footer>
</template>

<script type="text/ecmascript-6">
export default {
  methods: {
    goCommit: function () {
      this.$router.push({
        path: "/comment",
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// footer.vue?72e80a30